import React from "react";
import FailedOrdersTable from "../../../../component/views/seller/orders/failedOrdersTable";
import "./style.css";

const SellerFailedOrders = () => {
  return (
    <div className="seller-failed-orders-container">
      {/* Use the reusable FailedOrdersTable component */}
      <FailedOrdersTable 
        showHeader={true}
        showFilters={false}
      />
    </div>
  );
};

export default SellerFailedOrders;
